module.exports = __webpack_public_path__ + "static/media/trend-up.4a5b3cb7.svg";